import Radio from '@liveauctioneers/caterwaul-components/lib/Radio/Radio';
import Radios from '@liveauctioneers/caterwaul-components/lib/Radio/Radios';
import { BodySecondary, Caption } from '@liveauctioneers/caterwaul-components/lib/Text/Text';
import * as React from 'react';
import isEqual from 'react-fast-compare';
import styled from 'styled-components';

import { FacetOption as FacetOptionType } from '@/types/FacetOption';

type Props = {
    onChange: Function;
    options: FacetOptionType[];
};

const RadioFacet = ({ onChange, options }: Props) => {
    const mapOptions = React.useCallback(
        (option) => (
            <StyledRadioToggler
                disabled={Boolean(option.count < 1)}
                key={option.id}
                label={
                    <StyledTextOptionName suppressHydrationWarning>
                        {option.name}
                        {!isNaN(option.count) && (
                            <StyledTextOptionResultsCount>
                                <span>({Number(option.count).toLocaleString()})</span>
                            </StyledTextOptionResultsCount>
                        )}
                    </StyledTextOptionName>
                }
                name={option.id}
            />
        ),
        []
    );
    if (options.length < 1) {
        return null;
    }
    return (
        <div>
            <StyledToggleOption
                onChange={onChange}
                selectedName={options.find((op) => op.selected)?.id}
            >
                {options.map(mapOptions)}
            </StyledToggleOption>
        </div>
    );
};

export default React.memo<Props>(RadioFacet, isEqual);

const StyledToggleOption = styled(Radios)`
    padding: 5px 5px 5px 0;
`;

const StyledRadioToggler = styled(Radio)`
    margin-top: 0;

    input[type='checkbox'] {
        display: none;
    }
`;

const StyledTextOptionName = styled(BodySecondary)`
    text-transform: none;

    > :first-child {
        color: ${({ theme }) => theme.colors.grey100};
        font-size: 12px;

        &::before {
            content: ' ';
        }
    }
`;

const StyledTextOptionResultsCount = styled(Caption)`
    font-family: ${({ theme }) => theme.typography.fontPrimary};
    color: ${({ theme }) => theme.colors.grey100};

    &::before {
        content: '\u00a0';
        display: inline-block;
    }
`;
